var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import _ from "underscore";
import { defineStore } from "pinia";
import { reactive } from "vue";
import NotificationEndpoints from "src/shared/api/notification/NotificationEndpoints";
import UserNotification from "./model/UserNotification";
import { toPromise } from "src/shared/api/promise";
import Session from "Session";
import NotificationCursor from "./model/NotificationCursor";
import dateTimeService from "src/shared/date-time-service";
const convertNotificationFetchParameters = (parameters) => {
    return Object.assign(Object.assign(Object.assign({}, (parameters.offset !== undefined && {
        offset: String(parameters.offset),
    })), (parameters.limit !== undefined && {
        limit: String(parameters.limit),
    })), (parameters.was_snoozed !== undefined && {
        was_snoozed: parameters.was_snoozed,
    }));
};
export const useNotificationStore = defineStore("notificationStore", () => {
    const state = reactive({
        notifications: {},
        notificationCursor: null,
    });
    const fetchAllNotifications = (parameters = {}) => __awaiter(void 0, void 0, void 0, function* () {
        const notificationsResponse = yield toPromise(NotificationEndpoints.list(convertNotificationFetchParameters(parameters)));
        state.notifications = {};
        setNotifications(notificationsResponse);
    });
    const fetchNotificationsForUser = (userId, parameters = {}) => __awaiter(void 0, void 0, void 0, function* () {
        const notificationsResponse = yield toPromise(NotificationEndpoints.listByUserId(userId, convertNotificationFetchParameters(parameters)));
        state.notifications = {};
        setNotifications(notificationsResponse);
    });
    const fetchNotifications = (userId, parameters = {}) => __awaiter(void 0, void 0, void 0, function* () {
        if (!Session.getInstance().isSuperUser() &&
            userId === Session.getInstance().getUserId()) {
            yield fetchAllNotifications(parameters);
        }
        else {
            yield fetchNotificationsForUser(userId, parameters);
        }
    });
    const fetchNotificationCursor = () => __awaiter(void 0, void 0, void 0, function* () {
        const notificationCursorResponse = yield toPromise(NotificationEndpoints.getNotificationCursor());
        setNotificationCursor(notificationCursorResponse);
    });
    const setNotifications = (notificationsResponse) => {
        _.each(notificationsResponse, (response) => {
            const notification = new UserNotification(response);
            state.notifications[response.event_id] = notification;
        });
    };
    const setNotificationCursor = (notificationCursorResponse) => {
        const notificationCursor = new NotificationCursor(notificationCursorResponse);
        state.notificationCursor = notificationCursor;
    };
    const getNotifications = () => {
        return _.values(state.notifications);
    };
    const getNotification = (id) => {
        return state.notifications[id];
    };
    const getNotificationCursor = () => {
        return state.notificationCursor;
    };
    const readNotifications = () => __awaiter(void 0, void 0, void 0, function* () {
        const time = dateTimeService.formatToQueryDateTime();
        yield NotificationEndpoints.updateNotificationCursor({
            last_read_event_time: time,
        });
        yield fetchNotificationCursor();
    });
    return {
        state,
        fetchNotifications,
        fetchNotificationsForUser,
        fetchAllNotifications,
        fetchNotificationCursor,
        getNotification,
        getNotifications,
        getNotificationCursor,
        readNotifications,
    };
});
